define("shared/components/shared/credentials/upgrade-button", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/service", "@glimmer/component", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _service, _component2, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::Button
    @additional={{@additional}}
    @promise={{this.connectBusiness}}
    @runningText={{t "shared_phrases.please_wait"}}
    @size="regular"
    @text={{this.text}}
    @variant="outline"
    class={{@buttonClass}}
    data-social-profile-refresh-id="business-upgrade-button"
    title={{if @socialProfile.errorText @socialProfile.errorText this.text}}
    ...attributes
  />
  */
  {
    "id": "EU7WTp4J",
    "block": "[[[8,[39,0],[[16,0,[30,1]],[24,\"data-social-profile-refresh-id\",\"business-upgrade-button\"],[16,\"title\",[52,[30,2,[\"errorText\"]],[30,2,[\"errorText\"]],[30,0,[\"text\"]]]],[17,3]],[[\"@additional\",\"@promise\",\"@runningText\",\"@size\",\"@text\",\"@variant\"],[[30,4],[30,0,[\"connectBusiness\"]],[28,[37,2],[\"shared_phrases.please_wait\"],null],\"regular\",[30,0,[\"text\"]],\"outline\"]],null]],[\"@buttonClass\",\"@socialProfile\",\"&attrs\",\"@additional\"],false,[\"shared/ui/button\",\"if\",\"t\"]]",
    "moduleName": "shared/components/shared/credentials/upgrade-button.hbs",
    "isStrictMode": false
  });
  let UpgradeButtonComponent = _exports.default = (_dec = (0, _service.inject)('social/instagram-auth'), (_class = class UpgradeButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "instagramAuth", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _defineProperty(this, "connectBusiness", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          if (this.args.socialProfile.isInstagramLogin) {
            this.instagramAuth.refreshInstagramLogin.perform({
              socialProfile: this.args.socialProfile
            });
          } else {
            yield this.instagramAuth.authenticateWithFacebookGraphApi.perform({
              refreshSocialProfiles: [this.args.socialProfile]
            });
          }
        }
      }), null, "connectBusiness", null));
    }
    get text() {
      const fallbackText = this.intl.t('shared_phrases.missing_user_token.button');
      return this.args.buttonText ? this.args.buttonText : fallbackText;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "instagramAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UpgradeButtonComponent);
});